import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="footer">
            <div className="d_1">
                <div className="img-container"><img src="/assets/footer/logo.svg" alt="footer" /></div>
                <div className="routes">
                    <Link to="/">Home</Link>
                    <Link to="/sitemap">Sitemap</Link>
                    <Link to="/privacy">Privacy</Link>
                </div>
            </div>
        </div>
    );
};
export default Footer;